import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { lineStrings } from 'constants/strings';

type LineBulkActionBarProps = {
  selectedCount: number;
  isProcessing: boolean;
  onVerify: () => void;
  onChangeStatus: () => void;
  onChangeFriendLimit: () => void;
  onClearSelection: () => void;
};

export function LineBulkActionBar({
  selectedCount,
  isProcessing,
  onVerify,
  onChangeStatus,
  onChangeFriendLimit,
  onClearSelection,
}: LineBulkActionBarProps) {
  const strings = lineStrings.management.bulk;

  return (
    <div className="sticky top-4 z-20 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-accent/40 bg-white/95 px-4 py-3 shadow-[0_18px_44px_rgba(15,23,42,0.12)] backdrop-blur-sm sm:px-5">
      <div className="flex items-center gap-3">
        <span className="inline-flex h-7 min-w-[1.75rem] items-center justify-center rounded-full bg-accent px-2 text-sm font-bold tabular-nums text-white">
          {selectedCount}
        </span>
        <span className="text-sm font-semibold text-ink">
          {strings.selectedSuffix}
        </span>
        <button
          type="button"
          onClick={onClearSelection}
          disabled={isProcessing}
          className="inline-flex items-center gap-1 rounded-lg px-2 py-1 text-xs font-medium text-muted transition hover:bg-border/30 hover:text-ink disabled:cursor-not-allowed disabled:opacity-50"
        >
          <Icon icon="close" width={14} height={14} />
          {strings.clearSelection}
        </button>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button
          type="button"
          size="sm"
          disabled={isProcessing}
          onClick={onVerify}
        >
          <span className="inline-flex items-center gap-1.5">
            <Icon icon="check" width={16} height={16} />
            {strings.actions.verify}
          </span>
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          disabled={isProcessing}
          onClick={onChangeStatus}
        >
          <span className="inline-flex items-center gap-1.5">
            <Icon icon="menuSettings" width={16} height={16} />
            {strings.actions.status}
          </span>
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          disabled={isProcessing}
          onClick={onChangeFriendLimit}
        >
          <span className="inline-flex items-center gap-1.5">
            <Icon icon="menuUsers" width={16} height={16} />
            {strings.actions.friendLimit}
          </span>
        </Button>
      </div>
    </div>
  );
}
